$ = require 'jquery'
React = require 'react'
ReactDOM = require 'react-dom'
ReactRootComponent = require 'views/internal/react-root-component'
View = require 'view'
GracePeriodBanner = require 'views/board-limits/grace-period-banner'

module.exports = class GracePeriodBannerView extends View
  initialize: (model, modelCache) ->
    @$reactRoot ?= $('<div></div>')

  renderContent: ->
    React.createElement GracePeriodBanner,
      model: @model
      modelCache: @modelCache

  getReactRoot: ->
    React.createElement ReactRootComponent, {}, @renderContent()

  render: ->
    @$el.append(@$reactRoot)
    ReactDOM.render(@getReactRoot(), @$reactRoot[0])
    @



// WEBPACK FOOTER //
// ./app/scripts/views/board-limits/grace-period-banner-view.coffee